export default "__VITE_ASSET__Yanu2ls$__"